import React from 'react';
import CurrencyInMobile from '../components/MainLayout/CurrencyInMobile/CurrencyInMobile';
const CurrencyPage = () => {
  return (
    <>
      <CurrencyInMobile />
    </>
  );
};

export default CurrencyPage;
